import React from "react";
import "./Newbanner.css";
import robotBanner from "../../Component/machine.png";

const annotations = [
  {
    id: "offline-sim",
    title: "OFFLINE SIMULATION",
    desc: "Validate. Optimize.\nPerfect.",
    color: "orange",
    style: { top: "2%", left: "47%" },
    align: "left",
  },
  {
    id: "digital-mfg",
    title: "DIGITAL MANUFACTURING",
    desc: "Process planning\n& cell layout",
    color: "blue",
    style: { top: "20%", right: "2%" },
    align: "right",
  },
  {
    id: "robot-prog",
    title: "ROBOT PROGRAMMING",
    desc: "Offline programming\n& simulation",
    color: "blue",
    style: { top: "36%", left: "0%" },
    align: "left",
  },
  {
    id: "automation",
    title: "AUTOMATION",
    desc: "Integrated systems.\nIntelligent solutions.",
    color: "green",
    style: { bottom: "4%", right: "1%" },
    align: "right",
  },
  {
    id: "fixture-design",
    title: "FIXTURE DESIGN",
    desc: "Robust & precise\nfixture engineering",
    color: "purple",
    style: { bottom: "2%", left: "10%" },
    align: "left",
  },
];

const capabilities = [
  { label: "Tool Design", icon: "🛠" },
  { label: "Robotic Simulation", icon: "🤖" },
  { label: "Digital Manufacturing", icon: "🏭" },
  { label: "IT Technologies", icon: "💻" },
];

export default function BuildingIndustryBanner() {
  return (
    <section className="bib-banner">
      <div className="bib-inner">
        {/* Left content */}
        <div className="bib-content">
          <p className="bib-eyebrow">
            Industry-Focused. Practical. Future-Ready.
          </p>

          <h1 className="bib-heading">
            Building
            <br />
            Industry-Ready
            <br />
            <span className="bib-heading-accent">Engineers</span>
          </h1>

          <p className="bib-subtext">
            From Concept to Reality.
            <br />
            From Classroom to Industry.
          </p>

          <ul className="bib-capabilities" role="list">
            {capabilities.map((cap) => (
              <li key={cap.label} className="bib-capability">
                <span className="bib-capability-icon" aria-hidden="true">
                  {cap.icon}
                </span>
                <span className="bib-capability-label">{cap.label}</span>
              </li>
            ))}
          </ul>

          <div className="bib-cta-row">
            <a href="#programs" className="bib-btn bib-btn-primary">
              Explore Programs <span aria-hidden="true">→</span>
            </a>
            <a href="#centers" className="bib-btn bib-btn-secondary">
              Explore IIA Centers <span aria-hidden="true">📍</span>
            </a>
          </div>
        </div>

        {/* Right visual */}
        <div className="bib-visual">
          

          <div className="bib-image-wrap">
            <img
              src={robotBanner}
              alt="Robotic welding cell with offline programming, digital manufacturing, fixture design and automation annotations"
              className="bib-image"
            />

            {annotations.map((a) => (
              <div
                key={a.id}
                className={`bib-annotation bib-annotation--${a.color} bib-annotation--${a.align}`}
                style={a.style}
              >
                <span className="bib-annotation-title">{a.title}</span>
                <span className="bib-annotation-desc">
                  {a.desc.split("\n").map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}